/* eslint-disable @typescript-eslint/no-unused-vars */
import { connect } from "react-redux";
import { Dispatch } from "@reduxjs/toolkit";
import { ResourceInfo } from "@/services";
import { OrderForm } from ".";
import { ISettingStore } from "@/redux/slices/settings/SettingModel";
import { AttendeeInfo } from "@/services/attendee-service/entity/AttendeeEntity";
import { baContainer } from "@/ioc";
import { IOrderService, TokenIOrderService } from "@/services/order-service";
import { ResourceAllowOrderForm } from "./Models";
import { IOrganizationStore } from "@/redux/slices/organizations/OrganizationModel";
import { IRcResourceService, TokenIRcResourceService } from "@/services/rc-resource-service";
import { IOutlookAppointmentService, TokenIOutlookAppointmentService } from "@/out-look/services";
import { CheckExternalResourcesRequest } from "@/services/rc-resource-service/entity/request";
import { MovingOrderSessionModel } from "@/services/order-service/entity/MovingOrderSessionModel";
import { EMessageType } from "@/services/notification-service/entity/NotificationEnum";
import { addNotification } from "@/redux/slices/notification/NotificationSlice";
import { NotificationInfo } from "@/services/notification-service/entity/NotificationEntity";
import { OrderDataRequest } from "@/services/rc-resource-service/entity/OrderDataRequest";

export interface OrderFormContainerProps {
  Resource: ResourceInfo;
  setLoading: (loading: boolean) => void;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mapDispatchToProps = (dispatch: Dispatch<any>) => {
  return {
    statusAllowOrderForm: (resource: ResourceInfo, originalSelectedResources: ResourceInfo[] | []): ResourceAllowOrderForm => {
      const rcResourceService: IRcResourceService = baContainer.resolve(TokenIRcResourceService);
      return rcResourceService.getStatusAllowOrderForm(resource, originalSelectedResources);
    },
    IsBookingExistsOrder: function (): boolean {
      const olAppointmentService: IOutlookAppointmentService = baContainer.resolve(TokenIOutlookAppointmentService);
      return olAppointmentService?.GetCurrentAppointment()?.HaveNormalOrder || false;
    },
    IsMoveOrder: async function (request: OrderDataRequest, currentResource: ResourceInfo, selectedResource: ResourceInfo[], originalSelectedResources: ResourceInfo[]): Promise<boolean> {
      const orderService: IOrderService = baContainer.resolve(TokenIOrderService);

      const isAllowMovingOrder = await orderService.IsAllowMovingOrder({
        Request: request,
        CurrentResource: currentResource,
        CurrentSelected: selectedResource,
        OriginalSelected: originalSelectedResources,
      });
      console.log("🚀 ~ isAllowMovingOrder:", isAllowMovingOrder);
      console.log("🚀 ~ currentResource:", currentResource);

      if (isAllowMovingOrder) {
        return (true && originalSelectedResources[0].orders?.haveNormalOrder) || false;
      }
      return false;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    OnPlaceOrder: (
      isMoveOrder: boolean,
      request: OrderDataRequest,
      currentResource: ResourceInfo,
      selectedResource: ResourceInfo[],
      originalSelectedResources: ResourceInfo[],
      attendees: AttendeeInfo[],
      settings: ISettingStore,
      orgStore: IOrganizationStore
    ) => {
      const orderService: IOrderService = baContainer.resolve(TokenIOrderService);
      if (isMoveOrder) {
        orderService
          .CheckMovingOrderCondition({
            Request: request,
            CurrentResource: currentResource,
            CurrentSelected: selectedResource,
            OriginalSelected: originalSelectedResources,
          })
          .then((movingOrderSession: MovingOrderSessionModel | undefined) => {
            // dispatch(PopupMessageActionCreator.HideMaskDelay());
            if (movingOrderSession && movingOrderSession?.ResourcesCalculated?.IsMoveable) {
              orderService.SaveMovingOrderSession(movingOrderSession);
              dispatch(
                addNotification([
                  new NotificationInfo({
                    messageType: EMessageType.MoveOrder,
                    message: movingOrderSession.Message,
                    resourceInfo: currentResource,
                    isRecurring: false,
                    buttons: movingOrderSession.Buttons,
                  }),
                ])
              );
            }
          });
      } else {
        orderService.ShowPlaceOrderDialog(false, currentResource, selectedResource, attendees, settings, orgStore);
      }
    },
    
  };
};

export default connect(null, mapDispatchToProps)(OrderForm);
